import React, {useState} from 'react';

import {Cadastro, Especialidades} from '../../../../data/interfaces';
import {Container, InputText, ImgLupa, SelectEspcialidade} from './styles';

interface OwnProps {
  cadastros: Cadastro[];
  cadastrosTmp: Cadastro[];
  onChange: Function;
}
type Props = OwnProps;

export default function Busca({cadastros, cadastrosTmp, onChange}: Props) {
  const [especialidadeEscolhida, setEspecialidadeEscolhida] = useState<string>(
    'Todos',
  );
  const [chave, setChave] = useState<string>('');

  function handleBuscar() {
    console.log(especialidadeEscolhida);
    console.log(cadastros.length);
    console.log(cadastrosTmp.length);
    const busca: Cadastro[] = cadastrosTmp.filter(
      ({especialidade, nome}) =>
        especialidadeEscolhida==="Todos"?
          nome.toUpperCase().includes(chave.toUpperCase())
        :
          especialidade === especialidadeEscolhida &&
          nome.toUpperCase().includes(chave.toUpperCase())
    );
    if (busca.length > 0) {
      onChange(busca);
    } else {
      onChange(cadastrosTmp);
    }
    setChave('');
  }

  return (
    <Container>
      <InputText
        type="text"
        value={chave}
        onChange={(value: React.ChangeEvent<HTMLInputElement>) =>
          setChave(value.target.value)
        }
        placeholder="Busca ..."
      />
      <SelectEspcialidade
        value={especialidadeEscolhida}
        onChange={(ev: React.ChangeEvent<HTMLSelectElement>): void =>
          setEspecialidadeEscolhida(ev.target.value)
        }
        id="selectEspecialidades">
        <option value="Todos">Todos</option>
        <option value={Especialidades.CARDIOLOGISTA}>
          {Especialidades.CARDIOLOGISTA}
        </option>
        <option value={Especialidades.FISIOTERAPIA}>
          {Especialidades.FISIOTERAPIA}
        </option>
        <option value={Especialidades.MEDICINA_ESPOTIVA}>
          {Especialidades.MEDICINA_ESPOTIVA}
        </option>
        <option value={Especialidades.NUTRICIONISTA}>
          {Especialidades.NUTRICIONISTA}
        </option>
        <option value={Especialidades.ORTOPEDISTA}>
          {Especialidades.ORTOPEDISTA}
        </option>
        <option value={Especialidades.PERSONAL}>
          {Especialidades.PERSONAL}
        </option>
        <option value={Especialidades.PSICOLOGO}>
          {Especialidades.PSICOLOGO}
        </option>
        <option value={Especialidades.TRATAMENTO_ALTERNATIVO}>
          {Especialidades.TRATAMENTO_ALTERNATIVO}
        </option>
      </SelectEspcialidade>
      <ImgLupa
        onClick={() => {
          handleBuscar();
        }}
      />
    </Container>
  );
}
